import { useMemo } from 'react';
import { type AlboConfigurazioneTipoDTO } from '../configuration/api/schemas/alboConfigurazioneTipoDTO.ts';
import { type RegisterRecordFieldVisibility } from '../schema/RegisterRecordFieldVisibility.ts';
import { getRegisterRecordTypeColumns } from '../utils/getRegisterRecordTypeColumns.tsx';
import { sortRegisterRecordsTypeField } from '../utils/sortRegisterRecordsTypeField.ts';

interface IUseRegisterRecordsTable {
  registerRecordType: AlboConfigurazioneTipoDTO | null;
  registerRecordFieldVisibility?: RegisterRecordFieldVisibility;
}

/**
 * Hook per ottenere le colonne della tabella dei record di un albo e il campo di default
 */
export function useRegisterRecordsTable(props: IUseRegisterRecordsTable) {
  const { registerRecordType, registerRecordFieldVisibility } = props;

  const defaultFieldName = useMemo(() => {
    const fields = registerRecordType?.configurazioneCampi ?? [];
    const filteredFields = registerRecordFieldVisibility
      ? fields.filter(f => f[registerRecordFieldVisibility])
      : fields;

    const sortedFields = sortRegisterRecordsTypeField(filteredFields);

    const defaultFieldName = sortedFields[0]?.codice ?? 'statoIscrizione';

    return defaultFieldName;
  }, [registerRecordType, registerRecordFieldVisibility]);

  const registerRecordColumns = useMemo(() => {
    const registerRecordsTypeColumns = getRegisterRecordTypeColumns(
      registerRecordType,
      registerRecordFieldVisibility,
    );
    return registerRecordsTypeColumns;
  }, [registerRecordType, registerRecordFieldVisibility]);

  return { defaultFieldName, registerRecordColumns };
}
